var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD2CButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 232,
    height: 67,
    viewBox: "0 0 232 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187065",
    "data-name": "Group 187065",
    transform: "translate(-120 -245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_595",
    "data-name": "Ellipse 595",
    transform: "translate(139 260)",
    fill: "#6c38ff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 99,
    cy: 18.5,
    rx: 99,
    ry: 18.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99,
    cy: 18.5,
    rx: 98.5,
    ry: 18,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_61804",
    "data-name": "Rectangle 61804",
    transform: "translate(120 255)",
    fill: "#030319",
    stroke: "#926eff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 226,
    height: 46,
    rx: 23,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 225,
    height: 45,
    rx: 22.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Unlock_Your_D2C_Success",
    "data-name": "Unlock Your D2C Success",
    transform: "translate(145 284)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "SFProDisplay-Regular, SF Pro Display"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Unlock Your D2C Success")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD2CButton);
export default __webpack_public_path__ + "static/media/d2cButton.0be4aebdcaf831d73c5061ad1bba1bd4.svg";
export { ForwardRef as ReactComponent };